import api from './api';

export const createAnnouncement = async ({ title, body, target, pinned, expiresAt, links, youtubeUrl }) => {
  const res = await api.post('/announcements', { title, body, target, pinned, expiresAt, links, youtubeUrl });
  return res.data;
};

export const previewAnnouncement = async ({ title, body, target, previewEmail, expiresAt, links, youtubeUrl }) => {
  const res = await api.post('/announcements/preview', { title, body, target, previewEmail, expiresAt, links, youtubeUrl });
  return res.data;
};

export const listAnnouncements = async (params = {}) => {
  const res = await api.get('/announcements', { params });
  return res.data;
};

export const deleteAnnouncement = async (id) => {
  const res = await api.delete(`/announcements/${id}`);
  return res.data;
};
